import { Alert, Button } from "../../components";
import { Suspense, useEffect, useState } from "react";
import { btnGroup, mainText, subtitle } from "../../shared.module.scss";
import {
  checkDeviceStatus,
  getError,
  getLicenseFormState,
  getSelectedDeviceData,
} from "../../redux/voiceControl-slice";
import {
  getErrorMsg,
  isValid,
  validateForm,
} from "../../services/validation-service";
import { ValidatedInput } from "./ValidatedInput";
import cn from "classnames";
import { deviceInfoMessages } from "../../constants/voice";
import { licenseCheckFirmwareValidation } from "../../shared/validation";
import { loadTestComponent } from "../../utils";
import { useAbortableAsyncThunk } from "../../hooks";
import { useFormatMessage } from "../../i18n";
import { useSelector } from "react-redux";

const errorMessages = {
  DEVICE_ACCESS_DENIED: "error_device_access_denied",
  NOT_FOUND: "error_device_not_found",
  SERVER_ERROR: "something_went_wrong",
  GATEWAY_TIMEOUT: "error_device_time_out",
};

export function CheckFirmwareForm({ formik, isDeviceSelected }) {
  const [pristine, setPristine] = useState(true);
  const [infoMessage, setInfoMessage] = useState(null);
  const error = useSelector(getError);
  const tr = useFormatMessage();
  const { checkDeviceInProgress } = useSelector(getLicenseFormState);
  const deviceSelected = useSelector(getSelectedDeviceData);
  const { dispatchWithAbort } = useAbortableAsyncThunk(
    checkDeviceStatus,
    deviceSelected.cloudId
  );

  useEffect(() => {
    setInfoMessage(null);
  }, [deviceSelected.cloudId]);

  async function validateCheckForm() {
    setPristine(false);
    if (isValid(validationErrors)) {
      const data = await dispatchWithAbort(formik.values.cloudId);
      if (
        data.meta.requestStatus === "fulfilled" &&
        data.payload.status !== "ok"
      ) {
        setInfoMessage(data.payload.status);
      }
    }
  }

  const validationErrors = validateForm(
    { form: formik.values },
    licenseCheckFirmwareValidation
  );
  const errorMessage = tr(
    errorMessages[error.type] || errorMessages.SERVER_ERROR
  );

  const licenseCloudIdErrorMessage = getErrorMsg(validationErrors, "cloudId");

  const TestingWrapper = loadTestComponent(
    () => import("../../components/test/TestingWrapper")
  );

  const VoiceControlTestErrorButtons = loadTestComponent(
    () => import("../../components/test/VoiceControlTestErrorButtons")
  );

  return (
    <>
      {!isDeviceSelected && (
        <ValidatedInput
          label={tr("cloud_id")}
          id="cloudId-input"
          name="cloudId"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.cloudId}
          errors={licenseCloudIdErrorMessage}
          pristine={pristine}
        />
      )}
      <span className={cn(subtitle, mainText)}>
        {tr("users_should_check_firmware_before_assignation")}
      </span>
      {(error || infoMessage) && (
        <Alert severity={"error"}>
          {error ? errorMessage : tr(deviceInfoMessages[infoMessage])}
        </Alert>
      )}
      <div className={btnGroup}>
        <Button
          loading={checkDeviceInProgress}
          title={tr("check_firmware")}
          disabled={checkDeviceInProgress}
          variant="primary"
          type={"button"}
          onClick={() => {
            validateCheckForm();
          }}
        />
      </div>
      <Suspense fallback={<></>}>
        <TestingWrapper>
          <VoiceControlTestErrorButtons
            errors={Object.keys(errorMessages)}
            global={true}
          />
        </TestingWrapper>
      </Suspense>
    </>
  );
}
